import React from "react";
import { Link } from "@StarberryUtils";
import { GetURL } from "../Common/site/functions";

const GuideDetailsLink = ({ module }) => (
    <Link to={`/${GetURL(module.CTA_Link.id)[0]}`} className="btn btn-primary">{module.CTA_Label}<i className="icon-arrow"></i></Link>
)

export default GuideDetailsLink
